import { Button, MenuItem, Select, Tooltip } from '@mui/material';
import { Add, DeleteOutlined } from '@mui/icons-material';
import { Drawer, Button as AntdButton, Modal } from "antd";
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import Loading from "components/Loading";
import {
  getLabels,
  moodsOption,
  pronounOptions,
  question_type_generate_more_worksheet,
  validateEditForm,
  validateForm,
} from "modules/workSheet/helper";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useCurrentUser } from "store/users/selectors";
import {
  
  handleSaveQuestionBank,
  handleUpdateWorksheetBank,
  handleUpdateWorkSheetLog,
} from "store/worksheet/thunks";
import styled from "styled-components";
import QuestionComponent from "./questionTypeComponent";
import ValidationErrorSummary from "./validationErrorSummary";
// import { handleQuestionAudioWorkSheet } from "store/vocabulary/thunks";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import SentryWrap from 'components/Sentry';

const AdminTypes = ({
  isOpen = false,
  isEdit = false,
  selectedItem = {},
  dataTab,
  onClose = () => {},
  handleEditBackWard = () => {},
  handleEditForward = () => {},
  handleDeleteQuestionBank = () => {},
  fetchWorksheets = () => {},
  onUpdateWorksheet = () => {},
}) => {
  const showAlert = useAlert();
  const [questions, setQuestions] = useState([
    {
      type: "Fill_IN_THE_Blank",
      options: ["", ""],
    },
  ]);
  const [loading, setLoading] = useState({ type: "", value: false });
  const currentUser = useCurrentUser();
  const [showErrors, setShowErrors] = useState(false);
  const dispatch = useDispatch();
  const errorRef = useRef(null);
  const [nouns, setNouns] = useState([]);
  const [hintDetail, setHintDetail] = useState([""]);
  const [formErrors, setFormErrors] = useState({ isValid: "" });
  const [typeChangeModal, setTypeChangeModal] = useState({
    open: false,
    index: null,
    currentType: null,
    newType: null,
  });
  const questionRefs = useRef([]);
  const modalContentRef = useRef(null);

  useEffect(() => {
    if (!formErrors?.isValid && errorRef.current && showErrors) {
      errorRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [formErrors, showErrors]);

  const normalizeQuestionData = (item) => {
    if (!item) return item;
    
    const normalized = { ...item };
    
    const moodByLabel = moodsOption?.find((x) => x?.label === item?.mood);
    const moodByValue = moodsOption?.find((x) => x?.value?.toString() === item?.mood?.toString());
    if (moodByLabel) {
      normalized.mood = moodByLabel.label;
    } else if (moodByValue) {
      normalized.mood = moodByValue.label;
    }
    if (normalized.mood) {
      const moodObj = moodsOption?.find((x) => x?.value?.toString() === normalized.mood?.toString() || x?.label === normalized.mood);
      if (moodObj && moodObj.tenseOptions) {
        const tenseByLabel = moodObj.tenseOptions.find((x) => x?.label === item?.tense);
        const tenseByValue = moodObj.tenseOptions.find((x) => x?.value?.toString() === item?.tense?.toString());
        if (tenseByLabel) {
          normalized.tense = tenseByLabel.label;
        } else if (tenseByValue) {
          normalized.tense = tenseByValue.label;
        }
        
        if (normalized.tense) {
          const tenseObj = moodObj.tenseOptions.find((x) => x?.value?.toString() === normalized.tense?.toString() || x?.label === normalized.tense);
          if (tenseObj && tenseObj.categoryOptions) {
            const categoryByLabel = tenseObj.categoryOptions.find((x) => x?.label === item?.category);
            const categoryByValue = tenseObj.categoryOptions.find((x) => x?.value?.toString() === item?.category?.toString() || x?.label === item?.category);
            if (categoryByLabel) {
              normalized.category = categoryByLabel.label;
            } else if (categoryByValue) {
              normalized.category = categoryByValue.label;
            }
          }
        } else if (moodObj?.label === "Imperative" && moodObj.tenseOptions?.[0]?.categoryOptions) {
          const categoryByLabel = moodObj.tenseOptions[0].categoryOptions.find((x) => x?.label === item?.category);
          const categoryByValue = moodObj.tenseOptions[0].categoryOptions.find((x) => x?.value?.toString() === item?.category?.toString() || x?.label === item?.category);
          if (categoryByLabel) {
            normalized.category = categoryByLabel.label;
          } else if (categoryByValue) {
            normalized.category = categoryByValue.label;
          }
        }
      }
    }
    
    const pronounByLabel = pronounOptions?.find((x) => x?.label === item?.pronouns);
    const pronounByValue = pronounOptions?.find((x) => x?.value?.toString() === item?.pronouns?.toString() || x?.label === item?.pronouns);
    if (pronounByLabel) {
      normalized.pronouns = pronounByLabel.label;
    } else if (pronounByValue) {
      normalized.pronouns = pronounByValue.label;
    }
    
    return normalized;
  };

  useEffect(() => {
    if (isEdit && selectedItem) {
      const normalizedItem = normalizeQuestionData(selectedItem);
      setQuestions([normalizedItem]);
      setNouns([selectedItem.pronounsDetailOption]);
      setHintDetail([selectedItem.hintDetail]);
    }
  }, [isEdit, selectedItem]);

  const handleAddQuestion = () => {
    try {
      const lastQuestion =
        questions.length > 0 ? questions[questions.length - 1] : {};

      const newQuestion = {
        mood: lastQuestion.mood || null,
        pronouns: lastQuestion.pronouns || null,
        category: lastQuestion.category || null,
        tense: lastQuestion.tense || null,
        type: lastQuestion.type || "Fill_IN_THE_Blank",
        options: ["", ""],
        id: String(Date.now()),
      };

      setQuestions((prevQuestions) => {
        const updated = [...prevQuestions, newQuestion];

        setTimeout(() => {
          const lastRef = questionRefs.current[updated.length - 1];
          if (lastRef?.current && modalContentRef?.current) {
            // Ensure scrolling is inside modal content
            lastRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start", // or "center" if you want a bit lower
            });
          }
        }, 100);

        return updated;
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleQuestionDataChange = (index, questionData) => {
    setQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      updatedQuestions[index] = {
        ...JSON.parse(JSON.stringify(updatedQuestions[index])),
        ...questionData,
      };
      return updatedQuestions;
    });
  };

  const handleRemoveQuestion = (index) => {
    if (questions?.length === 1) {
      showAlert("Atleast one question is required", "error");
      return;
    }
    const updatedQuestions = questions.filter((_, i) => i !== index);
    setQuestions(updatedQuestions);
  };

  const handleClose = () => {
    setQuestions([
      {
        type: "Fill_IN_THE_Blank",
        options: ["", ""],
      },
    ]);
    onClose();
    setNouns([]);
    setHintDetail([]);
    setShowErrors(false);
    setFormErrors({});
  };

  const handleApprove = async () => {
    try {
      setLoading({ type: "approveQuestion", value: true });
      
      const selectedValue = JSON.parse(JSON.stringify(questions[0]));

      const isValidForm = validateEditForm(selectedValue, nouns, hintDetail);
      if (!isValidForm?.isValid) {
        setFormErrors(isValidForm);
        setShowErrors(true);
        showAlert("Please require all field's", "error");
        return;
      }
      const { id, ...dataWithoutId } = selectedValue;
      const dataLog = {
        question_id: selectedValue?.id,
        user_id: currentUser?.id,
        question_title: selectedValue?.question,
        message_type: "approved",
      };
      const payload = {
        id: selectedValue?.id,
        question: dataWithoutId,
        is_verified: true,
      };
      const result = await dispatch(handleUpdateWorksheetBank(payload));
      handleUpdateWorkSheetLog(dataLog);

      if (!result?.id) {
        showAlert("Something went wrong, please try again!", "error");
      } else {
        showAlert("Question approved successfully!", "success");
        handleEditForward(selectedItem);
        onUpdateWorksheet();
      }
    } catch (error) {
      console.log(error);
      showAlert("Something went wrong, please try again!", "error");
    } finally {
      setLoading({ type: "approveQuestion", value: false });
    }
  };

  const handleEdit = async () => {
    try {
      setLoading({ type: "editQuestion", value: true });

      // Create a deep copy of the first question
      const selectedItem = JSON.parse(JSON.stringify(questions[0]));

      const isValidForm = validateEditForm(selectedItem, nouns, hintDetail);
      if (!isValidForm?.isValid) {
        setFormErrors(isValidForm);
        setShowErrors(true);
        showAlert("Please require all field's", "error");
        return;
      }

      let moodObj;
      let tenseObj;
      
      const moodByValue = moodsOption?.find((x) => x?.value?.toString() === selectedItem?.mood?.toString());
      const moodByLabel = moodsOption?.find((x) => x?.label === selectedItem?.mood);
      moodObj = moodByValue || moodByLabel;
      
      if (moodObj) {
        selectedItem.mood = moodObj.label;
        
        if (selectedItem?.tense) {
          const tenseByValue = moodObj.tenseOptions?.find((x) => x?.value?.toString() === selectedItem.tense?.toString());
          const tenseByLabel = moodObj.tenseOptions?.find((x) => x?.label === selectedItem.tense);
          tenseObj = tenseByValue || tenseByLabel;
          
          if (tenseObj) {
            selectedItem.tense = tenseObj.label;
            
            if (selectedItem?.category && tenseObj.categoryOptions) {
              const categoryByValue = tenseObj.categoryOptions.find((x) => x?.value?.toString() === selectedItem.category?.toString());
              const categoryByLabel = tenseObj.categoryOptions.find((x) => x?.label === selectedItem.category);
              const categoryObj = categoryByValue || categoryByLabel;
              
              if (categoryObj) {
                selectedItem.category = categoryObj.label;
              }
            }
          } else if (moodObj.label === "Imperative" && moodObj.tenseOptions?.[0]?.categoryOptions) {
            if (selectedItem?.category) {
              const categoryByValue = moodObj.tenseOptions[0].categoryOptions.find((x) => x?.value?.toString() === selectedItem.category?.toString());
              const categoryByLabel = moodObj.tenseOptions[0].categoryOptions.find((x) => x?.label === selectedItem.category);
              const categoryObj = categoryByValue || categoryByLabel;
              
              if (categoryObj) {
                selectedItem.category = categoryObj.label;
              } else {
                selectedItem.category = "Commands";
              }
            }
          }
        }
      }
      
      if (selectedItem?.pronouns) {
        const pronounByValue = pronounOptions?.find((x) => x?.value?.toString() === selectedItem.pronouns?.toString());
        const pronounByLabel = pronounOptions?.find((x) => x?.label === selectedItem.pronouns);
        const pronounObj = pronounByValue || pronounByLabel;
        
        if (pronounObj) {
          selectedItem.pronouns = pronounObj.label;
        }
      }
      selectedItem.pronounsDetailOption = nouns[0];
      selectedItem.hintDetail = hintDetail[0];

      if (isEdit) {
        const { id, ...dataWithoutId } = selectedItem;
        const payload = {
          id: selectedItem?.id,
          question: dataWithoutId,
        };
        const dataLog = {
          question_id: selectedItem?.id,
          user_id: currentUser?.id,
          question_title: selectedItem?.question,
          message_type: "updated",
        };
        await dispatch(handleUpdateWorksheetBank(payload));
        handleUpdateWorkSheetLog(dataLog);
        onUpdateWorksheet();
      }
      await handleEditForward(selectedItem);
      showAlert("Question Updated successfully!", "success");
      setFormErrors({});
    } catch (error) {
      console.log(error);
    } finally {
      setLoading({ type: "editQuestion", value: false });
    }
  };

  const handlerSave = async () => {
    try {
      setLoading({ type: "saveQuestion", value: true });

      if (Array.isArray(questions)) {
        // Create a deep copy of questions array
        const updatedQuestion = questions.map((question) =>
          JSON.parse(JSON.stringify(question))
        );

        updatedQuestion.forEach((data, index) => {
          const moodObj = moodsOption?.find((x) => x?.value === data?.mood);
          data.mood = moodObj?.label || data.mood;

          if (moodObj) {
            const tenseObj = moodObj.tenseOptions?.find(
              (x) => x?.value === data.tense
            );
            data.tense = tenseObj?.label || data.tenseOption;

            if (tenseObj) {
              const categoryObj = tenseObj.categoryOptions?.find(
                (x) => x?.value === data.category
              );
              data.category = categoryObj?.label || data.categories;
            } else if (moodObj?.label === "Imperative") {
              if (data?.category && data.category !== "") {
                data.category = "Commands";
              }
            }
          }
          data.pronouns = getLabels(data.pronouns, pronounOptions)?.toString();
          data.pronounsDetailOption = nouns[index];

          if (data?.type === "Fill_IN_THE_Blank") {
            data.hintDetail = hintDetail[index];
           // data.correct_answer = hintDetail[index]?.text;
          }
        });

        // Validate the form with the updated questions (not the state)
        const isValidForm = validateForm(updatedQuestion, nouns, hintDetail);

        if (!isValidForm?.isValid) {
          setShowErrors(true);
          setFormErrors(isValidForm);
          showAlert("Please fill all the required fields", "error");
          return;
        } else {
          setShowErrors(false);
          setFormErrors({});
        }

        const payload = {
          data: updatedQuestion,
          user_id: currentUser?.id,
          role: currentUser?.role,
          draft_status: true,
        };

        await dispatch(handleSaveQuestionBank(payload));
        fetchWorksheets();
        onUpdateWorksheet();
      }
      showAlert("Question Saved successfully!", "success");
      setShowErrors(false);
      handleClose();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading({});
    }
  };

  const handleQuestionTypeChangeReset = (index, type) => {
    if(isEdit){
      const currentQuestion = questions[index];
      if(currentQuestion.type === type){
        return;
      }
      setTypeChangeModal({
        open: true,
        index: index,
        currentType: currentQuestion.type,
        newType: type,
      });
      return;
    }
    const updatedQuestions = [...questions];

    if (type !== "Fill_IN_THE_Blank") {
      delete updatedQuestions[index].correct_answer;
      delete updatedQuestions[index].wrongAnswerFeedBack;
      delete updatedQuestions[index].answer_audio;
      delete updatedQuestions[index].highlightWords;
      updatedQuestions[index] = {
        ...updatedQuestions[index],
        type: type,
        options: ["", ""],
      };
    } else {
      delete updatedQuestions[index].correct_answer;
      delete updatedQuestions[index].wrongAnswerFeedBack;
      delete updatedQuestions[index].answer_audio;
      delete updatedQuestions[index].highlightWords;
      updatedQuestions[index] = {
        ...updatedQuestions[index],
        type: type,
      };
    }
    setQuestions(updatedQuestions);
  };

  const confirmTypeChange = () => {
    const { index, newType } = typeChangeModal;
    const updatedQuestions = [...questions];
    const currentQuestion = { ...updatedQuestions[index] };
    currentQuestion.type = newType;
    if(newType !== "Fill_IN_THE_Blank"){
      if(!currentQuestion.options || !Array.isArray(currentQuestion.options) || currentQuestion.options.length === 0){
        currentQuestion.options = ["", ""];
      }
      delete currentQuestion.highlightWords;
    }else{
      delete currentQuestion.options;
      currentQuestion.wrongAnswerFeedBack = "";
      currentQuestion.answer_audio = "";
      currentQuestion.correct_answer = "";
    }
    updatedQuestions[index] = currentQuestion;
    setQuestions(updatedQuestions);
    setTypeChangeModal({ open: false, index: null, currentType: null, newType: null });
  };

  const cancelTypeChange = () => {
    setTypeChangeModal({ open: false, index: null, currentType: null, newType: null });
  };

  const getTypeLabel = (typeValue) => {
    const typeObj = question_type_generate_more_worksheet?.find((type) => type.main === typeValue);
    return typeObj?.label || typeValue;
  };

  const getDeletedFields = (currentType, newType, question) => {
    const deletedFields = [];
    if(currentType === "Fill_IN_THE_Blank" && newType !== "Fill_IN_THE_Blank"){
      if(question?.highlightWords){
        deletedFields.push("highlightWords");
        deletedFields.push("correct_answer");
        deletedFields.push("wrongAnswerFeedBack");
        deletedFields.push("answer_audio");
      }
    }
    if(currentType !== "Fill_IN_THE_Blank" && newType === "Fill_IN_THE_Blank"){
      if(question?.options && Array.isArray(question.options) && question.options.length > 0){
        deletedFields.push("options");
        deletedFields.push("correct_answer");
        deletedFields.push("wrongAnswerFeedBack");
        deletedFields.push("answer_audio");
      }
    }
    if(currentType !== "Fill_IN_THE_Blank" && newType !== "Fill_IN_THE_Blank"){
      if(question?.highlightWords){
        deletedFields.push("highlightWords");
      }
    }
    return deletedFields;
  };

  return (
    <SentryWrap>
    <Drawer
      height="100%"
      onClose={() => handleClose()}
      placement="top"
      open={isOpen}
      key="quizNew"
      className="assignments-drawer"
    >
      <ButtonContainer className="flex items-center gap-10px">
        {isEdit && (
          <div>
            <div className="flex items-center justify-end gap-10px">
              <Tooltip title={"Previous Question"} placement="top">
                <AntdButton
                  icon={<ArrowLeftOutlined />}
                  onClick={() => handleEditBackWard(selectedItem)}
                  style={{ background: "#03999e", color: "white" }}
                  disabled={
                    (loading?.type === "saveQuestion" &&
                      loading?.value === true) ||
                    (loading?.type === "editQuestion" &&
                      loading?.value === true)
                  }
                />
              </Tooltip>

              <Tooltip title="Next Question" placement="top">
                <AntdButton
                  icon={<ArrowRightOutlined />}
                  onClick={() => handleEditForward(selectedItem)}
                  style={{ background: "#03999e", color: "white" }}
                  disabled={
                    (loading?.type === "saveQuestion" &&
                      loading?.value === true) ||
                    (loading?.type === "editQuestion" &&
                      loading?.value === true)
                  }
                />
              </Tooltip>
            </div>
          </div>
        )}
        <SaveButton>
          <Button
            variant="contained"
            color="primary"
            className="float-right  newAddQuestionWorkSheet"
            onClick={() => {
              if (isEdit) {
                handleEdit();
              } else {
                handlerSave();
              }
            }}
            disabled={
              (loading?.type === "saveQuestion" && loading?.value === true) ||
              (loading?.type === "editQuestion" && loading?.value === true) ||
              (loading?.type === "approveQuestion" && loading?.value === true)
            }
          >
            {(loading?.type === "saveQuestion" && loading?.value === true) ||
            (loading?.type === "editQuestion" && loading?.value === true) ? (
              <Loading white={true} size={18} />
            ) : null}
            {isEdit
              ? dataTab === "draft_question"
                ? "Update And Approve"
                : "Update"
              : "Save"}
          </Button>
          {isEdit && dataTab === "unverified_question" && (
            <Button
              variant="contained"
              color="success"
              className="float-right newAddQuestionWorkSheet"
              onClick={handleApprove}
              disabled={
                (loading?.type === "saveQuestion" && loading?.value === true) ||
                (loading?.type === "editQuestion" && loading?.value === true) ||
                (loading?.type === "approveQuestion" && loading?.value === true)
              }
              style={{ marginRight: "10px", backgroundColor: "#52c41a", color: "white" }}
            >
              {(loading?.type === "approveQuestion" && loading?.value === true) ? (
                <Loading white={true} size={18} />
              ) : null}
              Approved
            </Button>
          )}
          {!isEdit && (
            <div className="w-full flex items-center justify-end">
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                onClick={handleAddQuestion}
                className="float-right"
                style={{ maxWidth: "150px" }}
              >
                Add Question
              </Button>
            </div>
          )}
        </SaveButton>
        {isEdit && (
          <SaveButton
            style={{ right: dataTab === "draft_question" ? "187px" : "95px" }}
          >
            <Button
              color="error"
              className="float-right"
              onClick={handleDeleteQuestionBank}
              style={{ backgroundColor: "#d32f2f", color: "white" }}
            >
              Delete
            </Button>
          </SaveButton>
        )}
      </ButtonContainer>
      <Container>
        <ModalContent ref={modalContentRef}>
          {questions?.map((question, index) => {
            if (!questionRefs.current[index]) {
              questionRefs.current[index] = React.createRef();
            }
            return (
              <QuestionContainer key={index} ref={questionRefs.current[index]}>
                {!isEdit && (
                  <>
                    {questions?.length > 1 && (
                      <div className="w-full flex justify-end items-center DeleteBtnIcons">
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => handleRemoveQuestion(index)}
                          startIcon={<DeleteOutlined />}
                        />
                      </div>
                    )}
                    <QuestionText className="text-center QuestionText worksheetQuestionText">
                      Question: {index + 1}
                    </QuestionText>
                  </>
                )}

                {question?.type && (
                  <QuestionComponent
                    typeField={
                      <Select
                        fullWidth
                        value={question.type}
                        onChange={(e) => {
                          handleQuestionTypeChangeReset(index, e.target.value)
                        }}
                        displayEmpty
                        variant="outlined"
                        margin="normal"
                        className="questionComSlect mt-10px mb-10px"
                        disabled={false}
                      >
                        {question_type_generate_more_worksheet?.map((type) => (
                          <MenuItem key={type.value} value={type.main}>
                            {type.label}
                          </MenuItem>
                        ))}
                      </Select>
                    }
                    index={index}
                    questionData={question}
                    type={question.type}
                    editData={selectedItem}
                    isEdit={isEdit}
                    onQuestionChange={(data) =>
                      handleQuestionDataChange(index, data)
                    }
                    nouns={nouns}
                    setNouns={setNouns}
                    hintDetail={hintDetail}
                    setHintDetail={setHintDetail}
                    isOpen={isOpen}
                  />
                )}
              </QuestionContainer>
            );
          })}
          {Object?.keys(formErrors)?.length > 0 && !formErrors?.isValid ? (
            <div ref={errorRef}>
              <ValidationErrorSummary
                validateForm={formErrors}
                showErrors={showErrors}
              />
            </div>
          ) : null}
        </ModalContent>
      </Container>
      <Modal
        title="Confirm Type Change"
        open={typeChangeModal.open}
        onOk={confirmTypeChange}
        onCancel={cancelTypeChange}
        okText="Confirm"
        cancelText="Cancel"
      >
        <p>
          Are you sure you want to change the question type from{" "}
          <strong>{getTypeLabel(typeChangeModal.currentType)}</strong> to{" "}
          <strong>{getTypeLabel(typeChangeModal.newType)}</strong>?
        </p>
        {(() => {
          const currentQuestion = questions[typeChangeModal.index];
          const deletedFields = getDeletedFields(typeChangeModal.currentType, typeChangeModal.newType, currentQuestion);
          return deletedFields.length > 0 ? (
            <div style={{ marginTop: "15px" }}>
              <p style={{ color: "#ff4d4f", fontWeight: "600", marginBottom: "8px" }}>
                The following fields will be deleted:
              </p>
              <ul style={{ color: "#ff4d4f", marginLeft: "20px", marginTop: "5px" }}>
                {deletedFields.map((field, idx) => (
                  <li key={idx}>
                    <strong>{field === "options" ? "options" : field === "highlightWords" ? "highlight words" : 
                    field === "correct_answer" ? "correct answer" : field === "wrongAnswerFeedBack" ? "wrong answer feedback" : field === "answer_audio" ? "answer audio" : field}</strong>
                  </li>
                ))}
              </ul>
            </div>
          ) : null;
        })()}
        <p style={{ color: "#ff4d4f", marginTop: "15px" }}>
          This action will modify the question structure. Please review before confirming.
        </p>
      </Modal>
    </Drawer>
    </SentryWrap>
  );
};

export default AdminTypes;

const QuestionText = styled.div`
  font-size: 17px;
  font-weight: 600;
  display: inline-block;
  border-bottom: 2px solid #000;
  margin: 0 auto;
`;

const ButtonContainer = styled.div`
  position: absolute;
  top: 5px;
  right: 16px;
`;

const SaveButton = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  // padding-right: 24px;
`;

const Container = styled.div`
  width: 100%;
  margin-inline: auto;
  height: 100%;
  padding: 0px;
  gap: 10px;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    width: 90%;
  }

  @media screen and (max-width: 1200px) {
    width: 88%;
  }
`;

const ModalContent = styled.div`
  border: 4px dashed lightGrey;
  width: 100%;
  padding: 0px;
  overflow: auto;
  padding-inline: 15px;
  padding-top: 8px;
`;

const QuestionContainer = styled.div`
  border: 1px solid #ddd;
  padding: 15px;
  // margin-bottom: 15px;
  border-radius: 8px;
  padding-top: 10px;
  margin-bottom: 20px;
  margin-top: 10px;
`;
